import { AxiosResponse } from 'axios';
import api from './axiosConfig';
import { invalidando, invalidandoTudo } from './queryClient';
import { UserResponseDTO } from '../types/dtos';

export const CHAVES_USUARIO = {
  dominio: ['usuario'] as const,
  porId: (id: string) => ['usuario', id] as const,
};

const UserService = {
  // Não existe mais POST /api/v1/users: conta só nasce por /auth/register + /auth/verify-email,
  // que confere o e-mail (ver AuthService).

  // GET /api/v1/users
  getAllUsers: (): Promise<AxiosResponse<UserResponseDTO[]>> =>
    api.get('/users'),

  // GET /api/v1/users/{id}
  getUserById: (id: string): Promise<AxiosResponse<UserResponseDTO>> =>
    api.get(`/users/${id}`),

  // DELETE /api/v1/users/{id}
  // Sem invalidação: quem exclui a conta cai no /login com reload (cache morre junto).
  deleteUser: (id: string): Promise<AxiosResponse<void>> =>
    api.delete(`/users/${id}`),

  // POST /api/v1/users/me/verify-password
  verifyPassword: (password: string): Promise<AxiosResponse<boolean>> =>
    api.post('/users/me/verify-password', { password }),

  // PUT /api/v1/users/me/password
  changePassword: (currentPassword: string, newPassword: string): Promise<AxiosResponse<void>> =>
    api.put('/users/me/password', { currentPassword, newPassword }),

  // PUT /api/v1/users/me/name
  changeName: (name: string): Promise<AxiosResponse<UserResponseDTO>> =>
    api.put('/users/me/name', { name }).then(invalidando(CHAVES_USUARIO.dominio)),

  // PUT /api/v1/users/me/terms — aceite de quem já tinha conta antes dos Termos
  acceptTerms: (): Promise<AxiosResponse<UserResponseDTO>> =>
    api.put('/users/me/terms').then(invalidando(CHAVES_USUARIO.dominio)),

  // PUT /api/v1/users/me/sensitive-data-consent — autoriza os dados de saúde (LGPD art. 11, I).
  // Invalida tudo: as telas que tomaram 403 sem a autorização precisam buscar de novo.
  grantSensitiveDataConsent: (): Promise<AxiosResponse<UserResponseDTO>> =>
    api.put('/users/me/sensitive-data-consent').then(invalidandoTudo),

  // DELETE /api/v1/users/me/sensitive-data-consent — revoga e APAGA anamnese, registros,
  // fotos e conversas. Invalida tudo pelo mesmo motivo, ao contrário.
  revokeSensitiveDataConsent: (): Promise<AxiosResponse<UserResponseDTO>> =>
    api.delete('/users/me/sensitive-data-consent').then(invalidandoTudo),

  // GET /api/v1/users/me/data-export — cópia de todos os dados (LGPD art. 18), como arquivo.
  exportData: (): Promise<AxiosResponse<Blob>> =>
    api.get('/users/me/data-export', { responseType: 'blob' }),
};

export default UserService;
